import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router);
const list = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    component: () => import("@/pages/login.vue"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/index",
    component: () => import("@/pages/index.vue"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/getvideo",
    component: () => import("@/pages/getvideo.vue"),
    meta: {
      title: "视频分发"
    }
  },
  {
    path: "/video",
    component: () => import("@/pages/video.vue")
  },
  {
    path: "/goods",
    component: () => import("@/pages/goods.vue"),
    meta:{
      title: "未入库商品"
    }
  }
];

export default new Router({
  routes: list
});



// WEBPACK FOOTER //
// ./src/router/index.js